function js360Normalize(value) {
  return String(value || '').trim().toLowerCase();
}

class JerseyPersonalizerLive extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.fields = this.querySelector('[data-js360-fields]');
    this.nameInput = this.querySelector('[data-js360-name]');
    this.numberInput = this.querySelector('[data-js360-number]');
    this.status = this.querySelector('[data-js360-status]');
    this.productInfo = this.closest('.product__info-container') || document;
    this.form = document.getElementById(this.dataset.formId);

    if (!this.fields || !this.nameInput || !this.numberInput || !this.form) return;

    this.productInfo.addEventListener('change', (event) => {
      if (event.target === this.nameInput || event.target === this.numberInput) return;
      window.setTimeout(() => this.syncVisibility(), 0);
    });

    this.nameInput.addEventListener('input', () => this.updateProperties());
    this.numberInput.addEventListener('input', () => {
      const digits = this.numberInput.value.replace(/\D+/g, '').slice(0, 3);
      if (digits !== this.numberInput.value) this.numberInput.value = digits;
      this.updateProperties();
    });

    this.form.addEventListener('submit', (event) => {
      if (!this.isPersonalizationSelected()) return;
      if (this.nameInput.value.trim() || this.numberInput.value.trim()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.status.textContent = 'Enter a name, a number, or both before adding this jersey to the cart.';
      this.nameInput.focus();
    }, true);

    this.syncVisibility();
  }

  selectedPersonalizationValue() {
    const optionName = this.dataset.optionName;
    const checkedRadio = [...this.productInfo.querySelectorAll('input[type="radio"]:checked')]
      .find((input) => input.name === optionName);
    if (checkedRadio) return checkedRadio.value;

    const expectedSelectName = 'options[' + optionName + ']';
    const select = [...this.productInfo.querySelectorAll('select')]
      .find((candidate) => candidate.name === expectedSelectName);
    return select ? select.value : '';
  }

  isPersonalizationSelected() {
    return js360Normalize(this.selectedPersonalizationValue()) ===
      js360Normalize(this.dataset.yesValue || 'Yes');
  }

  syncVisibility() {
    const selected = this.isPersonalizationSelected();
    this.fields.hidden = !selected;

    if (!selected) {
      this.nameInput.value = '';
      this.numberInput.value = '';
      this.status.textContent = '';
    }

    this.updateProperties();
    if (selected) window.setTimeout(() => this.nameInput.focus(), 0);
  }

  updateProperties() {
    const selected = this.isPersonalizationSelected();
    const hasName = selected && Boolean(this.nameInput.value.trim());
    const hasNumber = selected && Boolean(this.numberInput.value.trim());

    this.nameInput.name = hasName ? this.nameInput.dataset.propertyName : '';
    this.numberInput.name = hasNumber ? this.numberInput.dataset.propertyName : '';

    if (selected && (hasName || hasNumber)) {
      this.status.textContent = 'Personalization: US$ 7 total, including when both fields are used.';
    } else if (selected) {
      this.status.textContent = 'Enter a name, a number, or both.';
    } else {
      this.status.textContent = '';
    }
  }
}

if (!customElements.get('jersey-personalizer-live')) {
  customElements.define('jersey-personalizer-live', JerseyPersonalizerLive);
}
